export type SessionContext = Readonly<{
    namespace: string
}>

export function createSessionContext(namespace: string): SessionContext {
    return Object.freeze({ namespace })
}

export function isSameSessionContext(first: SessionContext, second: SessionContext): boolean {
    return first.namespace === second.namespace
}
